import { TRootItems, useFolder } from '@modules/items';
import { StatusLabel } from '@shared/components';
import HomeContent from './HomeContent';

/**
 * Fetches the folder tree and shows a loader/error or the HomeContent.
 */
const Home = () => {
  const { data, error } = useFolder();

  return (
    <StatusLabel
      data={data}
      loadingMessage="Loading products..."
      error={error}
      errorMessage="Loading products failed!"
      render={(d) => <HomeContent data={d as TRootItems} />}
    />
  );
};

export default Home;
